import * as qs from "query-string-for-all";
import * as React from "react";
import axios from "axios";
import Loading from "src/components/general/Loading";
import Trace from "./Trace";
import { baseUrl } from "src/constants/ApiSettings";
import { ICouncil } from "src/interfaces";

// import ITrace from "../../../../interfaces/Trace";

interface IProps {
  council: ICouncil;
  selectedYear: string;
}

interface IState {
  traces: ITraceItem[];
}

interface ITraceItem {
  color: string;
  label: string;
  percentage: number;
}

const barStyleMap = [
  { color: "cct-chart-blue-dark", label: "Rates and Charges" },
  { color: "cct-chart-blue-light", label: "Operational Grants" },
  { color: "cct-chart-green", label: "Other Revenue" }
];

class StackedProgressBar extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      traces: []
    };
  }

  public componentDidMount() {
    this.generateTraces(this.props.council, this.props.selectedYear);
  }

  public componentWillReceiveProps(newProps: IProps) {
    if (newProps.selectedYear !== this.props.selectedYear) {
      this.generateTraces(newProps.council, newProps.selectedYear);
    }
  }

  public generateTraces = (council: ICouncil, selectedYear: string) => {
    if (!council) {
      return;
    }

    axios
      .all([
        axios.get(
          `${baseUrl}/ratesAndCharges?${qs.stringify({
            council: council.id,
            year: selectedYear
          })}`
        ),
        axios.get(
          `${baseUrl}/operatingGrants?${qs.stringify({
            council: council.id,
            year: selectedYear
          })}`
        ),
        axios.get(
          `${baseUrl}/otherRevenue?${qs.stringify({
            council: council.id,
            year: selectedYear
          })}`
        )
      ])
      .then(
        axios.spread((rates, ops, works) => {
          const traces: ITraceItem[] = [];
          // tslint:disable-next-line:no-console
          [rates.data[0], ops.data[0], works.data[0]].forEach(
            (data: any, index: number) => {
              traces.push({
                color: barStyleMap[index].color,
                label: barStyleMap[index].label,
                percentage: Math.round(data.value * 100) / 100
              });
            }
          );
          return traces;
        })
      )
      .then(traces => {
        this.setState({ traces });
      })
      // tslint:disable-next-line:no-console
      .catch(err => console.error(err));
  };

  public render() {
    if (!this.state.traces) {
      return <Loading />;
    }

    const { traces } = this.state;

    // need to scale traces
    // First collect all the values
    const originalTraces = traces.map((trace, index) => ({
      index,
      percentage: trace.percentage
    }));

    const total = originalTraces.reduce(
      (a: any, b: any) => a + b.percentage,
      0
    );

    if (total === 0) {
      return <div className="font-bold text-grey">Data unavailable</div>;
    }

    const scaledTraces = originalTraces.map(trace => ({
      index: trace.index,
      percentage: (trace.percentage / total) * 100
    }));

    const finalTraces = scaledTraces.map(trace => ({
      ...traces[trace.index],
      originalPercentage: traces[trace.index].percentage,
      percentage: trace.percentage
    }));

    return (
      <div className="c-progressbar w-full h-8 rounded-lg relative">
        {finalTraces
          ? finalTraces.map((trace, index) => {
              let position;

              if (index + 1 === traces.length && index === 0) {
                position = "both";
              } else if (index === 0) {
                position = "first";
              } else if (traces.length === index + 1) {
                position = "last";
              } else {
                position = "none";
              }

              return (
                <Trace
                  key={index}
                  position={position}
                  label={trace.label}
                  color={trace.color}
                  percentage={trace.percentage}
                  originalPercentage={trace.originalPercentage}
                />
              );
            })
          : null}
      </div>
    );
  }
}

export default StackedProgressBar;



// WEBPACK FOOTER //
// ./src/components/report/councilFinances/StackedProgressBar/index.tsx